import { NgModule } from '@angular/core';
import { NonNegativeNumberDirective } from './non-negative-number.directive';

@NgModule({
    declarations: [NonNegativeNumberDirective],
    exports: [NonNegativeNumberDirective]
})
export class NonNegativeNumberModule { }
